import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'invitacion-familiar',
    loadComponent: () =>
      import('./invitacion-familiar/invitacion-familiar.component').then((m) => m.InvitacionFamiliarComponent),
    title: 'Invitación — Amoxcalli Padres',
  },
  {
    path: 'padre',
    canActivate: [authGuard],
    loadChildren: () => import('./padre/padre.routes').then((m) => m.padreRoutes),
  },
  { path: '**', redirectTo: '/auth/login' },
];
